import { Injectable, Injector } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http/http';
import { Observable } from 'rxjs';
import { LoginService } from '../Services/login.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const loginService = this.injector.get(LoginService);
        let autorizacao = request.clone();

        if (loginService.estaLogado()) {
            autorizacao = request.clone({
                setHeaders: {
                    'Authorization': `Bearer ${loginService.getTokenFromSessionStorage()}`
                }
            });
            return next.handle(autorizacao);
        } else {
            return next.handle(request);
        }
    }
}
